import parseMap from '../../scripts/parseMap.mjs'
import BaseMap from '../../BaseMap.jsx'

export default function EmbeddedMap({mapData, ...props}) {
    const readMap = () => parseMap(mapData)

    return (
        <BaseMap
            readMap={readMap}
            {...props}
        />
    )
}
